import React, {useState} from 'react';
import {H2} from '../../../components/crousal/Headings';
import {Button, ButtonType, ButtonSize} from '../../../components/crousal/Button';
import {NumberInput} from '../../../components/crousal/NumberInput';

interface IProps {
    onChange: (step: number) => void;
}

export function Step3b({onChange}: IProps) {
    const [choosePrice, setChoosePrice] = useState(false);
    const [postingPrice, setPostingPrice] = useState(0);

    function handleNext() {
        onChange(4);
    }

    return (
        <div>
            <H2 className="ml-4">Step 3 - Pricing</H2>
            <div
                className="items-center lg:mt-6 text-30 flex justify-center lg:w-2/5 text-sm lg:mx-auto text-center">
                Our service takes a flat 30% fee for selling your account. Our suggested price for the account
                based on
                your description is “Price here”, this means that you would receive “Price*70% here”. Would you
                like to
                choose your own price?
            </div>
            {choosePrice ?
                <div>
                    <div className="flex justify-center text-center items-center mt-4">
                        <div className={"w-48"}>
                            <NumberInput
                                label={'Your posting price'}
                                value={postingPrice}
                                onChange={setPostingPrice}
                                className="p-2"
                            />
                        </div>

                        <div className={"w-48"}>
                            <NumberInput
                                label={'The amount you get'}
                                value={postingPrice}
                                onChange={setPostingPrice}
                                className="p-2"
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="mt-6 mb-10 text-md">
                        <Button type={ButtonType.DEFAULT} size={ButtonSize.DEFAULT} onClick={handleNext}>
                            Next
                        </Button>
                    </div>
                </div> :
                <div>
                    <div className="mt-6 mb-10 text-md">
                        <Button type={ButtonType.DEFAULT} size={ButtonSize.SMALL} onClick={() => setChoosePrice(true)}>
                            Yes
                        </Button>
                        <Button className={"ml-4"} type={ButtonType.CTA} size={ButtonSize.SMALL}
                                onClick={handleNext}>
                            No
                        </Button>
                    </div>
                </div>
            }
        </div>
    );
}
